import { TOAST_DEFAULT_OPTIONS } from '../constants/toastDefaultOptions';
import { ToastOptions } from '../types/ToastOptions';

export const createToastOptionsWithDefaults = (
  options: Partial<ToastOptions>,
): ToastOptions => ({
  ...TOAST_DEFAULT_OPTIONS,
  ...options,
});
